import { useUserStore } from '@/stores/user.js';

export function subscribeToCustomerCenterNotifications(onDisconnected, onAppointmentCreated, onBotAppointmentCancelled) {
    const userStore = useUserStore();
    
    // Protección: validar que el store y los datos necesarios estén disponibles
    if (!userStore?.profile?.customer_code || !userStore?.profile?.center_id) {
        console.warn('No se puede suscribir a notificaciones del centro: customer_code o center_id no disponible');
        return null;
    }
    
    // Validar que window.Echo esté disponible
    if (!window.Echo) {
        console.error('Laravel Echo no está inicializado. No se puede suscribir al canal de notificaciones del centro.');
        return null;
    }
    
    const customerCode = userStore.profile.customer_code;
    const center_id = userStore.profile.center_id;

    const channelName = `${customerCode}-${center_id}`;

    try {
        // Las reservas del bot/app las crea el cliente final, no un empleado.
        // Aunque `event.employeeId` coincida con el usuario logueado, éste NO es
        // quien creó la cita, así que debe recibir igualmente el toast.
        // Por eso no filtramos por employeeId en bot.appointment.*.
        // Para whatsapp.disconnected sí mantenemos el filtro: el empleado que
        // acaba de desconectar no necesita verse a sí mismo avisado.
        const channel = window.Echo.channel(channelName)
            .listen('.bot.appointment.created', (event) => {
                onAppointmentCreated?.(event);
            })
            .listen('.bot.appointment.cancelled', (event) => {
                onBotAppointmentCancelled?.(event);
            })
            .listen('.whatsapp.disconnected', (event) => {
                if (event.employeeId !== userStore.profile.id) {
                    onDisconnected?.(event);
                }
            });

        // Guarda el nombre del canal por si lo necesitas luego
        channel.name = channelName;

        return channel;
    } catch (error) {
        console.error('Error al suscribirse al canal de notificaciones del centro:', error);
        return null;
    }
}

export function unsubscribeFromCustomerCenterNotifications(channel) {
    if (!channel?.name) {
        console.warn('No se puede desuscribir: canal no válido');
        return;
    }

    // Validar que window.Echo esté disponible
    if (!window.Echo) {
        console.warn('Laravel Echo no está disponible. No se puede desuscribir del canal de notificaciones del centro.');
        return;
    }

    try {
        // IMPORTANTE: usamos stopListening (y no Echo.leave) porque el calendario
        // (Calendar.vue) comparte este mismo canal para recibir eventos bot.*.
        // Un Echo.leave() destruiría la suscripción de ambos. Con stopListening
        // quitamos sólo nuestros handlers; si quedan otros listeners, el canal
        // sigue vivo. Si nadie escucha, pusher-js lo recolecta solo.
        channel.stopListening('.bot.appointment.created');
        channel.stopListening('.bot.appointment.cancelled');
        channel.stopListening('.whatsapp.disconnected');
        console.log(`Handlers del layout removidos en el canal ${channel.name}`);
    } catch (error) {
        console.error('Error al desuscribirse del canal de notificaciones del centro:', error);
    }
}
